// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"userInfo_userInfo__cyRTT","userInfoTitle":"userInfo_userInfoTitle__0RQn6","userInfoSubtitle":"userInfo_userInfoSubtitle__Qw_y2"};